import type { ManifestDetail, PartyType } from '@/typings/bill'
import { PARTY_TYPES } from '@/const/party-types'
import { BillType } from '@/const'
import {
  createBillModel,
  createContactInfo,
  createDefaultContainer,
  createDefaultCargo,
} from '@/utils/bill-model'

/** HBL 发货人、收货人的固定顺序。 */
const DEFAULT_PARTIES_ORDER: PartyType[] = [PARTY_TYPES.SN, PARTY_TYPES.CO]

/** 创建默认parties数组 - 保证固定顺序 */
export const createHouseBillParties = () => {
  return DEFAULT_PARTIES_ORDER.map((partyType) => createContactInfo(partyType))
}

/** 创建 HBL 详情，保留分单专属默认值。 */
export function createHouseBill(): ManifestDetail {
  return {
    ...createBillModel(),
    previousBillType: BillType.MBL,
    consolidatedIndicator: true,
    parties: createHouseBillParties(),
  }
}

// 处理数据，接口返回null导致前端渲染异常
export function initializeHouseBill(detail: ManifestDetail) {
  // 初始化新字段
  if (!detail.parties || detail.parties.length === 0) {
    detail.parties = createHouseBillParties()
  }

  if (!detail.containers || detail.containers.length === 0) {
    const container = createDefaultContainer()
    detail.containers = [container]
  } else {
    // 如果接口返回的数据中有顶级的 cargos 数组，需要将其分组到对应的容器中
    if ((detail as any).cargos && Array.isArray((detail as any).cargos)) {
      const topLevelCargos = (detail as any).cargos

      // 为每个容器初始化 cargos 数组
      detail.containers.forEach((container) => {
        container.cargos = []
      })

      // 将顶级 cargos 按 groupId 分组到对应的容器中
      topLevelCargos.forEach((cargo: any) => {
        const targetContainer = detail.containers.find(
          (container) => container.groupId === cargo.groupId,
        )
        if (targetContainer) {
          targetContainer.cargos.push(cargo)
        }
      })

      // 删除顶级的 cargos 属性
      delete (detail as any).cargos
    } else {
      // 如果没有顶级 cargos，确保每个容器都有 cargos 数组
      detail.containers.forEach((container) => {
        if (!container.cargos) {
          container.cargos = [createDefaultCargo(container.groupId)]
        }
      })
    }

    // 确保每个容器至少有一个货物
    detail.containers.forEach((container) => {
      if (!container.cargos || container.cargos.length === 0) {
        container.cargos = [createDefaultCargo(container.groupId)]
      }
    })
  }
}
